import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import styled from 'styled-components';

const PasswordInput = styled.input.attrs((props) => ({
  type: props.show ? 'input' : 'password',
}))`
  width: 100%;
  height: 40px;
  margin: 5px auto;
  padding: 0 30px 0 10px;
  background: ${({ background }) => background || 'rgba(0, 0, 0, 0.01)'};
  color: ${({ color }) => color || '#333'};
  border-radius: ${({ borderRadius }) => borderRadius || '20px'};
  border: 1px solid #333;
  font-size: 16px;
  border: 1px solid ${({ error }) => (error ? 'rgba(257,0,0, 1)' : '#ddd')};
`;

const PasswordContainer = styled.div`
  width: 100%;
  display: flex;
  a {
    display: flex;
    align-items: center;
    justify-content: start;
    margin-left: -25px;
    width: 25px;
  }
`;

function Input({ disabled, ...props }) {
  const [show, setShow] = useState(false);

  return (
    <PasswordContainer>
      <PasswordInput show={show} disabled={disabled} {...props} />
      <a onClick={() => setShow(!show)} href>
        {show ? (
          <FaEye size={15} color="#333" />
        ) : (
          <FaEyeSlash size={15} color="#333" />
        )}
      </a>
    </PasswordContainer>
  );
}

Input.propTypes = {
  disabled: PropTypes.bool.isRequired,
};

export default Input;
